var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',{class:{ condensed: _vm.condensed },attrs:{"id":"table-component"}},[_c('thead',{staticClass:"table-header",class:{
      'all:hidden md:table-header-group': _vm.hideHeaderOnMobile,
      'sticky top-0 bg-white': _vm.stickyHeader,
    }},[_vm._t("tableHeaders")],2),_vm._t("tableBody",function(){return [_c('tbody',[_vm._t("tableRows")],2)]}),(_vm.$slots.tableFooterRows)?_c('tfoot',[_vm._t("tableFooterRows")],2):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }